define.alias("shared/components/shared/mavely/links/search", "settings/components/shared/mavely/links/search");